module.exports = __webpack_public_path__ + "img/team_steve.28e3d0f2.jpg";